/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

export const createParameter = (param: string[] = [], type?: string) => {
  if (param.length === 0) {
    return "";
  }

  return param
    ?.map((p: string) => {
      return `&${type}=${p}`;
    })
    .toString()
    .replaceAll(",", "");
};
